"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var _react = require("@emotion/react");

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var base = function base(theme) {
  return /*#__PURE__*/(0, _react.css)("color:", theme.color.monochrome.white, ";height:100%;display:flex;flex-direction:column;" + (process.env.NODE_ENV === "production" ? "" : ";label:base;"));
};

var scrollingContainer = process.env.NODE_ENV === "production" ? {
  name: "9xhbbe",
  styles: "flex-grow:1;overflow:hidden auto"
} : {
  name: "4dbenm-scrollingContainer",
  styles: "flex-grow:1;overflow:hidden auto;label:scrollingContainer;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var heading = function heading(theme) {
  return /*#__PURE__*/(0, _react.css)("padding:", theme.spacing[7], " ", theme.spacing[10], ";display:flex;align-items:center;h4{color:inherit;padding:", theme.spacing[3], ";padding-left:0;}" + (process.env.NODE_ENV === "production" ? "" : ";label:heading;"));
};

var controls = function controls(theme) {
  return /*#__PURE__*/(0, _react.css)("min-height:", theme.spacing[14], ";margin-left:auto;display:flex;align-items:center;&&>button{color:", theme.color.monochrome.white, ";opacity:0.5;&::before{background-color:", theme.color.monochrome.dark, ";}&:hover{opacity:1;}&:active:before{background-color:rgba(", theme.color.monochrome.mediumDark_rgba, ", 0.44);}}" + (process.env.NODE_ENV === "production" ? "" : ";label:controls;"));
};

var list = function list(theme) {
  return /*#__PURE__*/(0, _react.css)("color:inherit;padding:0 ", theme.spacing[10], " 0 ", theme.spacing[5], ";margin-top:-2px;&&>*{margin-top:2px;}" + (process.env.NODE_ENV === "production" ? "" : ";label:list;"));
};

var styles = {
  base: base,
  scrollingContainer: scrollingContainer,
  heading: heading,
  controls: controls,
  list: list
};
exports.styles = styles;
//# sourceMappingURL=Menu.styles.js.map